const CouplerManufacturingDataType = Object.freeze({
  Coupler: 'Coupler',
  HydraulicAttachment: 'Hydraulic Attachment',
  NonHydraulicAttachment: 'Non-Hydraulic Attachment',
});

export { CouplerManufacturingDataType };
